/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_ChannelInputs */

const en_create_channel = /** @type {(inputs: Create_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Channel`)
};

const id_create_channel = /** @type {(inputs: Create_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Saluran`)
};

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const es_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const fr_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const de_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const ja_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const zh_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const ar_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const it_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const ru_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const pt_create_channel = en_create_channel;

/** @type {(inputs: Create_ChannelInputs) => LocalizedString} */
const ko_create_channel = en_create_channel;

/**
* | output |
* | --- |
* | "Create Channel" |
*
* @param {Create_ChannelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_channel = /** @type {((inputs?: Create_ChannelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_ChannelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_channel(inputs)
	if (locale === "es") return es_create_channel(inputs)
	if (locale === "fr") return fr_create_channel(inputs)
	if (locale === "de") return de_create_channel(inputs)
	if (locale === "ja") return ja_create_channel(inputs)
	if (locale === "zh") return zh_create_channel(inputs)
	if (locale === "ar") return ar_create_channel(inputs)
	if (locale === "id") return id_create_channel(inputs)
	if (locale === "it") return it_create_channel(inputs)
	if (locale === "ru") return ru_create_channel(inputs)
	if (locale === "pt") return pt_create_channel(inputs)
	return ko_create_channel(inputs)
});